import React from 'react'
import PropTypes from 'prop-types'
import { localized } from 'decorators'
import { Button } from '.'
import { useStyles } from './approveButton.css'

const ApproveButton = (props) => {
  const classes = useStyles()

  const { entity, approving, localize } = props
  if (entity && !entity.isApproved && entity.id > 0) {
    return <Button isLoading={approving} disabled={approving} className={classes.root} icon='legal' color='secondary' onClick={props.onClick} title={localize('common.approveButtonTooltip')}>{localize('common.approveButton')}</Button>
  }
  return null
}

ApproveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  entity: PropTypes.object,
  approving: PropTypes.bool
}
ApproveButton.defaultProps = {
  approving: false
}

export default localized(ApproveButton)
